<script>
export default {
  name: 'services-helpers',
  computed: {
    servicesListLabel () {
      if (this.$store.state.config.company.service_name === '') {
        return this.$t('common.ui.selectService');
      }

      return this.$store.state.config.company.service_name;
    },
    serviceIsCyclic () {
      if (this.servicesEnabled && this.selectedService !== '') {
        if (this.isEditForm && !!this.selectedService && this.hasPeriodicityDates) {
          return true;
        } else {
          let service = this.allServices.filter(service => service.id === this.selectedService)[0];

          if (!service) {
            return false;
          }

          return !!service.periodicity;
        }
      }

      return false;
    },
    serviceIsCustomCyclic () {
      if (this.servicesEnabled && this.selectedService !== '') {
        let service = this.allServices.filter(service => service.id === this.selectedService)[0];

        if (!service) {
          return false;
        }

        if (!service.periodicity && this.isEditForm && !!this.selectedService && this.hasPeriodicityDates) {
          return true;
        }

        return false;
      }

      return false;
    },
    serviceIsPaidForFullCycle () {
      if (this.servicesEnabled && this.selectedService !== '') {
        let service = this.allServices.filter(service => service.id === this.selectedService)[0];

        if (!service) {
          return false;
        }

        if (service.periodicity) {
          if (this.isEditForm) {
            return this.periodicityPaymentType === 0;
          }

          return service.periodicity_payment_type === 0;
        } else {
          if (this.isEditForm && this.hasPeriodicityDates && this.periodicityPaymentType === 0) {
            return true;
          }

          if (!this.isEditForm && this.periodicity && this.periodicityPaymentType === 0) {
            return true;
          }
        }
      }

      return false;
    },
    serviceHasTickets () {
      if (this.servicesEnabled && this.selectedService !== '') {
        let service = this.allServices.filter(service => service.id === this.selectedService)[0];

        if (!service) {
          return false;
        }

        return !!service.tickets;
      }

      return false;
    },
    servicePeriodicities () {
      if (this.serviceIsCyclic) {
        let service = this.allServices.filter(service => service.id === this.selectedService)[0];

        if (!service) {
          return false;
        }

        let periodicities = JSON.parse(JSON.stringify(service.periodicities));
        periodicities.sort((a, b) => a.ordering - b.ordering);

        return periodicities;
      }

      return [];
    },
    serviceHasDates () {
      if (this.servicesEnabled && this.selectedService !== '') {
        let service = this.allServices.filter(service => service.id === this.selectedService)[0];

        if (!service) {
          return false;
        }

        return service.available_in_dates === 1;
      }

      return false;
    },
    serviceDateBlockTitle () {
      if (this.serviceHasDates) {
        if (this.serviceSelectedDate !== '') {
          return this.$t('common.ui.reservation.term') + ': ';
        }

        return this.$t('common.ui.reservation.term');
      }

      if (this.selectedDate.date !== '' && this.selectedDate.hour === '') {
        return this.$t('common.ui.reservation.date') + ': ';
      }

      if (this.selectedDate.date !== '' && this.selectedDate.hour !== '') {
        return this.$t('common.ui.reservation.date') + ': ';
      }

      return this.$t('common.ui.reservation.date');
    },
    serviceDateBlockSubTitle () {
      if (this.serviceHasDates) {
        if (this.serviceSelectedDate !== '') {
          return this.humanDateFormat(this.serviceSelectedDate, true);
        }

        return '';
      } else {
        if (this.errors.indexOf('base-datetime') > -1) {
          return this.$t('common.ui.reservation.selectTermRequired');
        }
      }

      if (this.useDaysMode) {
        if (this.selectedDate.date !== '') {
          return this.humanDateFormatRange(this.selectedDate.date, this.days, this.selectedServiceIsDailyEndAvailable);
        } else {
          return '';
        }
      }

      if (this.selectedDate.date !== '' && this.selectedDate.hour === '') {
        return this.humanDateFormat(this.selectedDate.date + ' ' + this.selectedDate.hour, false);
      }

      if (this.selectedDate.date !== '' && this.selectedDate.hour !== '') {
        return this.humanDateFormat(this.selectedDate.date + ' ' + this.selectedDate.hour, true);
      }

      return '';
    },
    serviceDateBlockClass () {
      if (this.termMessageFromEndpoint) {
        return 'danger-text';
      }

      if (this.serviceHasDates) {
        return 'default-text';
      } else {
        if (this.errors.indexOf('base-datetime') > -1) {
          return 'danger-text';
        }
      }

      if (this.selectedDateIsNotAvailable()) {
        return 'danger-text';
      }

      if (!this.useDaysMode) {
        if ((this.dateSearchMode === 'date' || this.usesCustomHour) && this.nearestDates.length) {
          let hourItem = this.nearestDates.filter(item => item.hour === this.selectedDate.hour);

          if (hourItem.length && hourItem[0].valid === 0) {
            return 'danger-text';
          }
        } else if ((this.dateSearchMode === 'nearest' || this.dateSearchMode === 'hour' || this.usesCustomHour) && this.nearestDates.length) {
          let dateItem = this.nearestDates.filter(item => item.date === this.selectedDate.date);

          if (dateItem.length) {
            let hourItem = dateItem[0].hours.filter(item => item.hour === this.selectedDate.hour);

            if (hourItem.length && hourItem[0].valid === 0) {
              return 'danger-text';
            }
          }
        }
      }

      return 'default-text';
    },
    serviceDateBlockTooltip () {
      if (this.serviceDateBlockClass === 'danger-text' && !this.termMessageFromEndpoint) {
        return this.$t('reservationForm.thisTermIsUnavailable');
      }

      return this.termMessageFromEndpoint;
    },
    showDatesWrapper () {
      return (
        (
          !this.servicesEnabled ||
          (
            this.servicesEnabled &&
            this.selectedService !== '' &&
            (
              !this.serviceIsCyclic ||
              (this.serviceIsCyclic && (this.isEditForm || (!this.isEditForm && !!this.periodicityType)))
            )
          )
        ) &&
        !this.nearestDatesAreLoading &&
        !this.nearestDatesMessage &&
        this.nearestDates.length &&
        (
          this.dateSearchMode === 'nearest' ||
          (this.dateSearchMode === 'date' && (this.selectedDate.date !== '')) ||
          (this.dateSearchMode === 'hour' && this.selectedDate.hour !== '')
        )
      );
    },
    servicePeopleRange () {
      if (this.servicesEnabled && this.selectedService !== '') {
        let service = this.allServices.filter(service => service.id === this.selectedService)[0];

        if (!service) {
          return '';
        }

        if (service.validate_people_number) {
          return this.$t('common.ui.reservation.preferredPeopleCount') + ': ' + service.min_people_number + ' - ' + service.max_people_number;
        }
      }

      return '';
    },
    selectedServiceHasCustomDuration () {
      if (this.servicesEnabled && this.selectedService !== '') {
        let service = this.allServices.filter(service => service.id === this.selectedService)[0];

        if (!service) {
          return false;
        }

        return !!service.custom_duration;
      }

      return false;
    },
    selectedServiceCustomDurations () {
      if (this.servicesEnabled && this.selectedService !== '') {
        let service = this.allServices.filter(service => service.id === this.selectedService)[0];

        if (!service) {
          return [];
        }

        return service.custom_durations;
      }

      return [];
    }
  },
  methods: {
    servicesInCategory (categoryID) {
      return this.services.filter(service => service.category_id === categoryID);
    },
    selectedServiceRequiresPeopleNumber () {
      if (!this.$store.state.config.company.people_required) {
        return false;
      }

      let result = true;
      let currentService = this.allServices.filter(service => service.id === parseInt(this.selectedService, 10));

      if (currentService.length) {
        return !!currentService[0].people_required;
      }

      return result;
    },
    checkIfServiceIsDaily (serviceID) {
      if (!serviceID) {
        return false;
      }

      let foundedService = this.allServices.filter(service => service.id === serviceID);

      if (foundedService[0]) {
        return foundedService[0].available_in_dates === 3;
      }

      return false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/ServicesHelpers.vue